import { createI18n } from 'vue-i18n'

import enUS from './locales/en-US.json'
import koKR from './locales/ko-KR.json'

import enUSDevice from './locales/en-US-Device.json'
import koKRDevice from './locales/ko-KR-Device.json'

type MessageSchema = typeof enUS

const i18n = createI18n<[MessageSchema], SupportedLocale>({
  legacy: false,
  locale: 'ko',
  messages: {
    en: { ...enUS, ...enUSDevice },
    ko: { ...koKR, ...koKRDevice }
  }
})

export default i18n
